import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsIsSupported, logEvent } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD_GcIh7hwqX901cglrGLYZh0nAiV1kc9c",
  authDomain: "eunoia-website-2ad6f.firebaseapp.com",
  projectId: "eunoia-website-2ad6f",
  storageBucket: "eunoia-website-2ad6f.firebasestorage.app",
  messagingSenderId: "661442361890",
  appId: "1:661442361890:web:b1fd2cfab17ce74587687b",
  measurementId: "G-43FYP4BWWZ",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export let analytics = null;
const analyticsReady = analyticsIsSupported().then((supported) => {
  if (supported) analytics = getAnalytics(app);
  return analytics;
});

export function trackEvent(name, params) {
  analyticsReady.then((instance) => {
    if (instance) logEvent(instance, name, params);
  });
}
